import React from 'react'
import PropTypes from 'prop-types'
import { SmoothStepEdge } from 'reactflow'

const CustomEdge = ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    data
}) => {
    const edgeStyle = {
        stroke: 'hsl(var(--grey))',
        strokeWidth: 2.5
    }
    return (
        <SmoothStepEdge
            id={id}
            sourceX={sourceX}
            sourceY={sourceY}
            targetX={targetX}
            targetY={targetY}
            sourcePosition={sourcePosition}
            targetPosition={targetPosition}
            data={data}
            style={edgeStyle}
            borderRadius={10}
            offset={20}
        />
    )
}

CustomEdge.propTypes = {
    id: PropTypes.string.isRequired,
    sourceX: PropTypes.number.isRequired,
    sourceY: PropTypes.number.isRequired,
    targetX: PropTypes.number.isRequired,
    targetY: PropTypes.number.isRequired,
    sourcePosition: PropTypes.string.isRequired,
    targetPosition: PropTypes.string.isRequired,
    data: PropTypes.object
}

export default CustomEdge
